module.exports = __webpack_public_path__ + "img/crime_scene_photography_splash.5cb3ab42.jpg";